// extracted by mini-css-extract-plugin
export default {"Container":"Spinner_Container__HfEEJ","Center":"Spinner_Center__-lqIE","spin":"Spinner_spin__Q9zsz"};